import { create } from 'zustand';
import { Filter } from '../domain/valueObjects/Filter';
import { Range } from '../domain/FilterTypes';
// Zustand store holding filter state (with reset/set actions)

type FilterStore = {
  polygonFeatures: GeoJSON.Feature[];
  setPolygonFeatures: (polygonFeatures: GeoJSON.Feature[] | ((prev: GeoJSON.Feature[]) => GeoJSON.Feature[])) => void;

  filter: Filter;
  setFilter: (filter: Filter | ((prev: Filter) => Filter)) => void;
  resetFilter: () => void;
};

const defaultFilter: Filter = {
  marketingStatus: 'FOR_SALE',
  zipcode: undefined,
  city: undefined,
  statusFlags: [ 'new', 'active' ],
  price: Range.create(null, null),
  beds: Range.create(null, null),
  baths: Range.create(null, null),
  homeTypes: [ 'house' ],
  timeOnMarket: Range.create(null, null),
  sqft: Range.create(null, null),
  lotSize: Range.create(null, null),
  stories: Range.create(null, null),
  yearBuilt: Range.create(null, null),
  pricePerSqft: Range.create(null, null),
  propertyTaxes: Range.create(null, null),
  sortBy: 'best_deal',
  sortDirection: 'desc',
};

export const useFilterStore = create<FilterStore>((set) => ({
  polygonFeatures: [],
  setPolygonFeatures: (polygonFeatures) =>
    set((state) => ({
      polygonFeatures: typeof polygonFeatures === 'function' ? polygonFeatures(state.polygonFeatures) : polygonFeatures,
    })),

  filter: defaultFilter,
  setFilter: (filter) =>
    set((state) => ({
      filter: typeof filter === 'function' ? filter(state.filter) : filter,
    })),

  resetFilter: () =>
    set(() => ({
      filter: defaultFilter
    })),

}));
